import React, { FC, ReactElement } from 'react'

import { ScheduleShift } from '../../../../entities/Shift/Shift'
import CalendarShift from '../CalendarShift/CalendarShift'

interface CalendarShiftsListProps {
    shifts: ScheduleShift[]
}

export const CalendarShiftsList: FC<CalendarShiftsListProps> = ({ shifts }): ReactElement => (
    <div className="shifts-list">
        {shifts
            .map(shift => {
                return (
                    <CalendarShift
                        key={shift.uuid}
                        shift={shift}
                    />
                )
            })
        }
    </div>
)

export default CalendarShiftsList
